import React from 'react';
import format from 'date-fns/format';

import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';

import { DateStampProps } from '../../types';

type Props = DateStampProps & { date: string };

const BaseDateStamp = (props: Props) => {
  const { className, overrides, date: dateProp } = props;
  const date = new Date(dateProp);

  return (
    <Stack
      alignItems="center"
      className={cn(
        'h-[5.4rem] w-[5.4rem] rounded-8 border border-border bg-bg-primary',
        className,
      )}
      direction="col"
      justifyContent="center">
      <Typography className="text-icon-error" variant="label-caps" {...overrides?.month}>
        {format(date, 'MMM')}
      </Typography>
      <Typography color="text-text-primary" variant="heading-xs" {...overrides?.date}>
        {format(date, 'd')}
      </Typography>
    </Stack>
  );
};

export default BaseDateStamp;
